import { useEffect, useRef } from "react";
import { useQuerySkills } from "src/queries/chat/chat.query";
import type { Skill } from "../ChatInput.types";

export interface UseSkillsReturn {
  skillsRef: React.RefObject<Skill[]>;
  updateDecorationsRef: React.RefObject<(() => void) | null>;
}

export function useSkills(): UseSkillsReturn {
  const skillsRef = useRef<Skill[]>([]);
  const updateDecorationsRef = useRef<(() => void) | null>(null);

  const { data: skillsData, isError: skillsError } = useQuerySkills<Skill[]>({
    queryKey: ["chat", "skills"],
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (skillsData) {
      skillsRef.current = skillsData;
    } else if (skillsError) {
      skillsRef.current = [];
    }

    updateDecorationsRef.current?.();
  }, [skillsData, skillsError]);

  return { skillsRef, updateDecorationsRef };
}
